
import { useState, useEffect, useRef } from "react";
import { toast } from "sonner";

// Default image to ensure we always have something to display
const DEFAULT_IMAGE = "https://ehskmwgoablwyqevwegt.supabase.co/storage/v1/object/public/images/Stock_Images/Nightclub6.jpg";

export const useBackgroundImage = (imageArray: string[]) => {
  const [backgroundImage, setBackgroundImage] = useState<string>(DEFAULT_IMAGE);
  const [isLoadingImage, setIsLoadingImage] = useState(true);
  
  // Track if component is mounted
  const isMountedRef = useRef(true);

  // Choose a random background image on page load
  useEffect(() => {
    isMountedRef.current = true;
    
    const loadRandomImage = async () => {
      setIsLoadingImage(true);
      
      try {
        // Select a random image from the array
        const randomIndex = Math.floor(Math.random() * imageArray.length);
        const selectedImage = imageArray[randomIndex];
        
        // Preload the selected image
        const img = new Image();
        
        const imageLoadPromise = new Promise<void>((resolve, reject) => {
          img.onload = () => resolve();
          img.onerror = () => reject(new Error(`Failed to load image: ${selectedImage}`));
          img.src = selectedImage;
        });
        
        await imageLoadPromise;
        
        // If component is still mounted, update the background image
        if (isMountedRef.current) {
          setBackgroundImage(selectedImage);
          setIsLoadingImage(false);
          console.log(`Loaded background image: ${selectedImage}`);
        }
      } catch (error) {
        console.error("Error loading background image:", error);
        
        // If there's an error, use the default image
        if (isMountedRef.current) {
          setBackgroundImage(DEFAULT_IMAGE);
          setIsLoadingImage(false);
          toast.error("Failed to load background image");
        }
      }
    };
    
    loadRandomImage();
    
    // Clean up function
    return () => {
      isMountedRef.current = false;
    };
  }, [imageArray]);

  return { backgroundImage, isLoadingImage };
};
